import React, { useState } from 'react';
import { useCurrency } from '../hooks/useCurrency';
import { GlobeIcon, ChevronDownIcon } from 'lucide-react';
import { CURRENCY_CONFIG, CountryCode } from '../utils/priceConfig';
const COUNTRY_FLAGS: Record<CountryCode, string> = {
  US: '🇺🇸',
  CL: '🇨🇱',
  CO: '🇨🇴',
  ES: '🇪🇸',
  IT: '🇮🇹',
  MX: '🇲🇽',
  UY: '🇺🇾'
};
interface CountrySelectorProps {
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
  className?: string;
}
export function CountrySelector({
  position = 'top-right',
  className = ''
}: CountrySelectorProps) {
  const {
    currency,
    changeCountry,
    availableCountries,
    isLoading
  } = useCurrency();
  const [isOpen, setIsOpen] = useState(false);
  const positionClasses = {
    'top-right': 'top-4 right-4',
    'top-left': 'top-4 left-4',
    'bottom-right': 'bottom-4 right-4',
    'bottom-left': 'bottom-4 left-4'
  };
  if (isLoading) return null;
  return <div className={`fixed ${positionClasses[position]} z-50 ${className}`} data-id="element-91">
      <div className="relative" data-id="element-92">
        <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 border border-gray-200" aria-label="Seleccionar país" data-id="element-93">
          <GlobeIcon className="w-4 h-4 text-gray-600" data-id="element-94" />
          <span className="text-sm font-medium" data-id="element-95">
            {COUNTRY_FLAGS[currency.countryCode as CountryCode]} {currency.code}
          </span>
          <ChevronDownIcon className={`w-4 h-4 text-gray-600 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-96" />
        </button>

        {isOpen && <>
            <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} data-id="element-97" />
            <div className="absolute top-full mt-2 right-0 bg-white rounded-lg shadow-xl border border-gray-200 py-2 min-w-[200px] z-50" data-id="element-98">
              {availableCountries.map(code => {
            const cfg = CURRENCY_CONFIG[code];
            const isSelected = currency.countryCode === code;
            return <button key={code} onClick={() => {
              changeCountry(code);
              setIsOpen(false);
            }} className={`w-full flex items-center gap-3 px-4 py-2 hover:bg-gray-50 transition-colors ${isSelected ? 'bg-gray-100' : ''}`} data-id="element-99">
                    <span className="text-xl" data-id="element-100">{COUNTRY_FLAGS[code]}</span>
                    <div className="flex-1 text-left" data-id="element-101">
                      <div className="text-sm font-medium text-gray-900" data-id="element-102">
                        {cfg.name}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-103">{cfg.code}</div>
                    </div>
                    {isSelected && <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-104" />}
                  </button>;
          })}
            </div>
          </>}
      </div>
    </div>;
}